import React, { useState, useCallback } from 'react';

import api from '../api';
import { useGet, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { Company } from '../types';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const CompaniesProvider: React.FC<Props> = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState<Array<Company>>([]);
    const [selected, setSelected] = useState<Company | null>(null);
    const [error, setError] = useState({});

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const handleUpdateData = useCallback((item, newData) => {
        setData(newData);
        setSelected(item);
    }, []);
    const handleError = useCallback((err) => {
        setError(err);
        throw err;
    }, []);
    const put = usePut(api, data, handleUpdateData, handleError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);

    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                get,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default CompaniesProvider;
